import { render, staticRenderFns } from "./TaxSetups.vue?vue&type=template&id=3224d8b2&"
import script from "./TaxSetups.vue?vue&type=script&lang=js&"
export * from "./TaxSetups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports